define('collections/Podio.Collections.Conversations',['require','underscore','jquery','lib/backbone/Backbone.PodioCollection','lib/Podio.Routes','models/Podio.Models.Conversation','lib/backbone/Backbone.Mixins.PodioInfiniteScrollCollection','lib/backbone/Backbone.Mixins.PodioCollectionDateComparator'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var PodioCollection = require('lib/backbone/Backbone.PodioCollection');
  var routes = require('lib/Podio.Routes');

  return PodioCollection.extend({
    url: function() {
      if (this.filter) {
        return routes.search_conversations_path($.extend({text: this.filter, participants: true }, this.flag ? {flag: this.flag} : {}));
      } else {
        return routes.conversations_path(this.flag ? {flag: this.flag} : {});
      }
    },

    configure: function() {
      this.model = require('models/Podio.Models.Conversation');
    },

    initialize: function(models, options) {
      var CollectionInfiniteScroll = require('lib/backbone/Backbone.Mixins.PodioInfiniteScrollCollection');
      _.extend(this, CollectionInfiniteScroll);

      this.filter = options.filter;
      this.flag = options.flag;
      if (options.itemsPerRequest) {
        this.itemsPerRequest = options.itemsPerRequest;
      }

      // Sort collection by last event timestamp
      var CollectionDateComparator = require('lib/backbone/Backbone.Mixins.PodioCollectionDateComparator');
      _.extend(this, CollectionDateComparator);
      this.dateComparatorAttribute = 'lastEventOrCreatedOn';

      if (options.maxItems) {
        this.on('add', this._checkSize.curry(options.maxItems));
      }
    },

    _checkSize: function(maxItems) {
      if (this.length > maxItems) {
        this.models = this.models.slice(0, maxItems);
      }
    },

    markAllRead: function(options) {
      var url = routes.conversations_mark_all_as_read_path();

      this.each(function(conversation) {
        conversation.set('unread', false);
        conversation.set('unread_count', 0);
      });

      if (!options || !options.surpressRequest) {
        return this.request('post', url);
      }
    },

    setFilter: function(filter) {
      if (filter !== this.filter) {
        this.filter = filter;
        this.reset();
      }
    },
  });

});

